import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

//React Globals
global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;
import { DemoComponent } from './test/demo';
import { GalleryComponent } from './components/gallery/gallery';
import { ChairsGalleryComponent } from './components/gallery/gallery';
import { CollectionGalleryComponent } from './components/gallery/gallery';
global.Components = {
  DemoComponent,
  GalleryComponent,
  ChairsGalleryComponent,
  CollectionGalleryComponent
};
global.serviceRootEndpoint = '/api';
//global.mediaFileBaseUrl ='https://leeimageserver.azurewebsites.net/azure/medialibrary/';
global.mediaFileBaseUrl = '';